export class Handbook {
  pageTitle = ''
  nameHandbook = ''
  vuexModuleNamespaced = ''
  link = ''

  constructor ({ pageTitle, nameHandbook, vuexModuleNamespaced, url }) {
    this.pageTitle = pageTitle
    this.nameHandbook = nameHandbook
    this.vuexModuleNamespaced = vuexModuleNamespaced
    this.link = url + this.nameHandbook
  }
}
